import React from 'react';

interface CheckboxProps {
	checked: boolean;
	onChange: () => void;
	label: string;
	/**
	 * Inline SVG markup from ocean_get_amenity_icon_svg() -- a theme file, not
	 * user input. Inlined rather than used as an <img src> so the icon's
	 * fill="currentColor" picks up the surrounding text colour.
	 */
	icon?: string | null;
	caveat?: string | null;
}

export const Checkbox = ({ checked, onChange, label, icon, caveat }: CheckboxProps) => {
	return (
		<label className="booking-bar__checkbox">
			<input
				type="checkbox"
				className="booking-bar__checkbox-input"
				checked={checked}
				onChange={onChange}
			/>
			<span className="booking-bar__checkbox-box" aria-hidden="true" />
			{icon && (
				<span
					className="booking-bar__checkbox-icon"
					aria-hidden="true"
					dangerouslySetInnerHTML={{ __html: icon }}
				/>
			)}
			<span className="booking-bar__checkbox-text">
				<span className="booking-bar__checkbox-label">{label}</span>
				{caveat && <span className="booking-bar__checkbox-caveat">{caveat}</span>}
			</span>
		</label>
	);
};
